const projectConstants = {
    PROJECT_REQUEST: 'PROJECT_REQUEST',
    PROJECT_SUCCESS: 'PROJECT_SUCCESS',
    PROJECT_FAILED: 'PROJECT_FAILED',
};

export default projectConstants;
